module.exports = __webpack_public_path__ + "2e4a06fa5f96819540de3af67c52449b.html";


//////////////////
// WEBPACK FOOTER
// ./src/portal/components/sp-editable-label/sp-editable-label.html
// module id = 999
// module chunks = 0